import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from "vue";
import SideBar from "@/components/SideBar.vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const container = ref<null | HTMLElement>(null);
const initWindow = () => {
  if (container.value) {
    let scale;
    if (window.innerWidth === 1088) {
      scale = window.innerWidth / 1920;
      container.value.setAttribute(
        "style",
        `transform: scale(${scale});margin-top: ${
          (window.innerHeight - 1080 * scale) / 2
        }px;margin-left:0;`
      );
      return;
    }
    scale = window.innerHeight / 1080;
    container.value.setAttribute(
      "style",
      `transform: scale(${scale});margin-left: ${
        (window.innerWidth - 1920 * scale) / 2
      }px;margin-top:0;`
    );
  }
};

onMounted(() => {
  initWindow();
  window.addEventListener("resize", initWindow);
});

onUnmounted(() => {
  window.removeEventListener("resize", initWindow);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    ref_key: "container",
    ref: container
  }, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, {
          include: [_unref(store).getters.cacheKeepAlive]
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1032, ["include"]))
      ]),
      _: 1
    })
  ], 512))
}
}

})